// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b664ac0d","455":"2e093776","977":"46baf0c7"}[chunkId] + ".chunk.js";
};